/* Alpacas Foods — abas da PDP (tablist ARIA). Porta a lógica de tabs do PDP.tsx. */
if (!customElements.get('alp-tabs')) {
  customElements.define('alp-tabs', class extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.tabs.forEach(function (tab) {
        tab.addEventListener('click', function () { this.select(tab.getAttribute('aria-controls')); }.bind(this));
      }.bind(this));
    }
    select(id) {
      this.tabs.forEach(function (t) {
        var on = t.getAttribute('aria-controls') === id;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.classList.toggle('is-on', on);
      });
      this.panels.forEach(function (p) {
        if (p.id === id) p.removeAttribute('hidden'); else p.setAttribute('hidden', '');
      });
    }
  });
}
